import ToolApprovalCard from '../ToolPart/components/ToolApprovalCard';
import { useRachelAgentApprovalCard } from './useRachelAgentApprovalCard';

const RachelAgentApprovalCard = () => {
  const {
    isPending,
    isDisabled,
    isExpanded,
    approvalPrompt,
    handleAllow,
    handleAllowAlways,
    handleAllowAllChat,
    handleDecline,
  } = useRachelAgentApprovalCard();

  if (!isPending) {
    return null;
  }

  return (
    <ToolApprovalCard
      prompt={approvalPrompt}
      isExpanded={isExpanded}
      onAllow={handleAllow}
      onAllowAlways={handleAllowAlways}
      onAllowAllChat={handleAllowAllChat}
      onDecline={handleDecline}
      disabled={isDisabled}
    />
  );
};

export default RachelAgentApprovalCard;
